export default __webpack_public_path__ + "static/media/Talion.3bae0c7c.jpg";